import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

import FeaturesTable from '../features-table/FeaturesTable';

const FeaturesTableBlock = ({
  headline,
  variation,
  showMobileDropdown,
  mobileDropdownLabel,
  showExpandListButton,
  expandListText
}) => (
  <FeaturesTable
    headline={headline}
    variation={variation}
    showMobileDropdown={showMobileDropdown}
    mobileDropdownLabel={mobileDropdownLabel}
    showExpandListButton={showExpandListButton}
    expandListText={expandListText}
  />
);

export const query = graphql`
  fragment FeaturesTableFragment on ContentfulFeaturesTable {
    id
    __typename
    headline
    variation
    showMobileDropdown
    mobileDropdownLabel
    showExpandListButton
    expandListText
    personalizations {
      ...PersonalizationFragment
    }
  }
`;

FeaturesTableBlock.propTypes = {
  headline: PropTypes.string,
  variation: PropTypes.string,
  showMobileDropdown: PropTypes.bool,
  mobileDropdownLabel: PropTypes.string,
  expandListText: PropTypes.string,
  showExpandListButton: PropTypes.bool
};

export default FeaturesTableBlock;
